import './ccf-format-bold-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfFormatBoldIconProps extends SvgIconProps {}
/**
 * component used to display format text as bold icon
 * @param props - CcfFormatBoldIconProps
 * @example - <CcfFormatBoldIcon />
 * @returns SVG of format text as bold icon
 */
export function CcfFormatBoldIcon(props: CcfFormatBoldIconProps) {
  return (
    <SvgIcon {...props}>
        <g id="format-bold-icon" data-name="Format_Bold" transform="translate(3.702 3.702)">
          <path d="M11.63,7.82A2.948,2.948,0,0,0,13,5.5,3.5,3.5,0,0,0,9.5,2H4V14h6.25a3.242,3.242,0,0,0,1.38-6.18ZM6.5,4H9.25a1.5,1.5,0,0,1,0,3H6.5Zm3.25,8H6.5V9H9.75a1.5,1.5,0,0,1,0,3Z"/><path className="a" />
        </g>
    </SvgIcon>
    
  );
}

export default CcfFormatBoldIcon;
